/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireHBI {
  position: number;
  question: string;
  answers: string[];
}

export const Q_HBI: QuestionnaireHBI[] = [
  {
    position: 1, question: 'Benessere del paziente (giorno precedente)' ,
      answers: [
      '0 = buono',
      '1 = leggermente inferiore alla norma',
      '2 = scarso',
      '3 = molto scarso',
      '4 = pessimo',
    ]
  },
  {
    position: 2, question: 'Dolore addominale (giorno precedente)',
    answers: [
      '0 = assente',
      '1 = lieve',
      '2 = moderato',
      '3 = severo'
    ]
  },
  {
    position: 3, question: 'Numero di evacuazioni liquide o molli',
    answers: null
  },
  {
    position: 4, question: 'Massa addominale',
    answers: [
      '0 = assente',
      '1 = dubbia',
      '2 = definita',
      '3 = definita e sensibile alla palpazione'
    ]
  },
  {
    position: 5, question: 'Presenza di complicanze',
    answers: ['No', 'Si']
  }
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class HBIResults {
  patientSSN: string;
  doctorID: string;
  results: string[];
  complications: string[];
  finalScore: number;

  constructor(doctorID: string, patientSSN: string, results: string[], complications: string[], finalScore: number) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.complications = complications;
    this.finalScore = finalScore;
  }

}
